import React from 'react';
import { ZoomIn, ZoomOut, Download, X } from 'lucide-react';

interface PdfModalProps {
  pdfUrl: string;
  pdfSource: 'backend' | 'legacy';
  pdfZoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onDownload: () => void;
  onClose: () => void;
  pageCount?: number;
}

const PdfModal: React.FC<PdfModalProps> = ({
  pdfUrl, pdfSource, pdfZoom, onZoomIn, onZoomOut, onDownload, onClose, pageCount
}) => {
  const sourceLabel = pdfSource === 'backend'
    ? '🖥️ Backend (Puppeteer)'
    : '📄 Legacy (Backend react-pdf)';

  const sourceColor = pdfSource === 'backend' ? '#4CAF50' : '#FF9800';

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-modal-header">
          <h2>
            PDF Preview
            <span style={{
              fontSize: '14px',
              marginLeft: '10px',
              padding: '4px 8px',
              borderRadius: '4px',
              backgroundColor: sourceColor,
              color: 'white'
            }}>
              {sourceLabel}
            </span>
          </h2>
          <div className="pdf-controls">
            <button onClick={onZoomOut} title="Zoom Out"><ZoomOut size={18} /></button>
            <span>{Math.round(pdfZoom * 100)}%</span>
            <button onClick={onZoomIn} title="Zoom In"><ZoomIn size={18} /></button>
            {typeof pageCount === 'number' && (
              <span style={{ fontSize: '14px', color: '#555', fontWeight: 500 }}>{pageCount} pages</span>
            )}
            <button onClick={onDownload} title="Download"><Download size={18} /></button>
            <button onClick={onClose} title="Close"><X size={18} /></button>
          </div>
        </div>
        <div className="pdf-viewer">
          <iframe
            src={pdfUrl}
            style={{ transform: `scale(${pdfZoom})`, transformOrigin: 'top center' }}
            title="PDF Preview"
          />
        </div>
      </div>
    </div>
  );
};

export default PdfModal;
